import { Component, signal } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs';

import { LoginFormComponent } from '../../components/forms/login-form/login-form.component';
import { AccessService } from '../../services/access/access.service';

@Component({
  selector: 'app-access',
  imports: [
    RouterLink,
    RouterLinkActive,
    LoginFormComponent
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  readonly isLoading = signal<boolean>(false);

  constructor(private readonly router: Router,
    private readonly accessService: AccessService,
    private readonly messageService: MessageService) { }

  login(fields: { email: string; password: string; }) {
    const { email, password } = fields;

    this.accessService.authenticate(email, password)
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: (res: { token: string }) => {
          this.accessService.setToken(res);
          this.router.navigate(['/']);
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'E-mail ou senha inválidos!',
            life: 4000
          });
        }
      });
  }
}
